import React from 'react';
import { Pagination as AntPagination } from 'antd';

const Pagination = ({ 
  currentPage, 
  totalPages, 
  onPageChange, 
  totalItems, 
  itemsPerPage,
  showInfo = true,
  showPageInfo,
}) => {
  // Use showPageInfo if provided, otherwise use showInfo
  const shouldShowInfo = showPageInfo !== undefined ? showPageInfo : showInfo;
  
  const defaultItemsPerPage = itemsPerPage || 10;
  const total = totalItems !== undefined ? totalItems : (totalPages * defaultItemsPerPage);
  
  // Use defaultItemsPerPage for the pageSize prop
  const pageSize = itemsPerPage || defaultItemsPerPage;

  // Handle page change - Ant Design onChange receives (page, pageSize)
  // We only care about the page number to maintain compatibility
  const handleChange = (page, pageSize) => {
    // Only call onPageChange with the page number to maintain backward compatibility
    // Ignore pageSize changes since the component doesn't support page size changes
    if (onPageChange) {
      onPageChange(page);
    }
  };

  // Custom showTotal function to match the original "Showing X to Y of Z proposals" format
  const showTotalFunction = (total, range) => {
    if (!shouldShowInfo) {
      return null;
    }
    // range[0] is the first item index (1-based), range[1] is the last item index
    // But we need to match the original format which shows "Showing X to Y of Z"
    const startItem = range[0];
    const endItem = range[1];
    return `Showing ${startItem} to ${endItem} of ${total} proposals`;
  };

  // Hide pagination if there's only one page or less
  if (totalPages <= 1) {
    return null;
  }

  return (
    <div className="d-flex justify-content-between align-items-center mt-4">
      <AntPagination
        current={currentPage}
        total={total}
        pageSize={pageSize}
        onChange={handleChange}
        showTotal={shouldShowInfo ? showTotalFunction : undefined}
        hideOnSinglePage={true}
        showSizeChanger={false}
        showQuickJumper={false}
      />
    </div>
  );
};

export default Pagination;